// extracted by mini-css-extract-plugin
export default {"pageHeroWrapper":"_H7lkn","grid":"O8XbyR","content":"_JrEwe","title":"px0JGs","subtitle":"sCxMAI","desktop":"vcSp7s","heroImage":"Tz3Jf3","mobile":"y1Yyo3"};